
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DocumentFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Document"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contentType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signedDocumentUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originalFileUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"needsPdfConversion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewDocumentUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verificationStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"signatureRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPatientSections"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPatientData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"read"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"readBy"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"verifiedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"verificationUser"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"office"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"OfficeFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"documentSections"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DocumentSectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"officeApiSyncState"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasFollowUps"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"followUpsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextFollowUpDueAt"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":718}};
    doc.loc.source = {"body":"#import \"./UserFragment.graphql\"\n#import \"./OfficeFragment.graphql\"\n#import \"./DocumentSectionFragment.graphql\"\n\nfragment DocumentFragment on Document {\n  id\n  name\n  description\n  createdAt\n  updatedAt\n  fileUrl\n  contentType\n  signedDocumentUrl\n  originalFileUrl\n  needsPdfConversion\n  previewDocumentUrl\n  title\n  verificationStatus\n  signatureRequired\n  completed\n  hasPatientSections\n  hasPatientData\n  read\n  readAt\n  readBy {\n    ...UserFragment\n  }\n  verifiedAt\n  verificationUser {\n    ...UserFragment\n  }\n  author {\n    ...UserFragment\n  }\n  office {\n    ...OfficeFragment\n  }\n  documentSections {\n    ...DocumentSectionFragment\n  }\n  officeApiSyncState\n  hasFollowUps\n  followUpsCount\n  nextFollowUpDueAt\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./UserFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./OfficeFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./DocumentSectionFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["DocumentFragment"] = oneQuery(doc, "DocumentFragment");
        
